import { LoaderArgumentsMap } from "../load-manager";
import { Observable } from "rxjs";
import { LgFilterSet } from "@logex/framework/lg-filterset";
import { InjectionToken } from "@angular/core";
import { FilterFactoryCreator } from "@shared/filter-factory";

export const VAR_FILTER_PROVIDER = new InjectionToken<
    IVariationFilterProvider | IVariationFilterProvider[]
>("variationFilterProvider");
export interface IVariationFilterProvider {
    pagekey: string;
    defaultReferencesParams: { [key: string]: string | number };

    init(
        source: (filterName: string, argsOverride?: LoaderArgumentsMap) => Observable<any>,
        extParams: _.Dictionary<any>
    ): FilterFactoryCreator<any, {}>;
    _getLoaderArguments(filterContext: LgFilterSet<any, any>);
    _createLoaders(
        args: LoaderArgumentsMap,
        action: (filterName: string, args: LoaderArgumentsMap) => any
    );
    _getLocalizedFilters();
}
